import React from "react";
import "./UserTableSkeleton.scss";

/**
 * Ultra-Modern User Table Skeleton Loader
 * Beautiful, contemporary skeleton with smooth animations and gradients
 * Matches the exact structure and styling of the admin user table
 *
 * @param {number} rows - Number of skeleton rows to display (default: 5)
 */
const UserTableSkeleton = ({ rows = 5 }) => {
  return (
    <>
      {[...Array(rows)].map((_, rowIndex) => (
        <tr key={rowIndex} className="user-row skeleton-row ultra-modern-skeleton">
          {/* Status Column */}
          <td>
            <div className="status-toggle-wrapper">
              <div className="skeleton-status-toggle">
                <div className="skeleton-status-track">
                  <div className="skeleton-status-handle" />
                </div>
              </div>
            </div>
          </td>

          {/* Full Name Column */}
          <td>
            <div className="user-info">
              <div className="user-avatar skeleton-avatar" />
              <div className="user-name skeleton-name" />
            </div>
          </td>

          {/* Email Column */}
          <td className="user-email">
            <div className="skeleton-email" />
          </td>

          {/* Company Column */}
          <td>
            <div className="company-info">
              <div className="company-icon skeleton-icon" />
              <span className="skeleton-text" />
            </div>
          </td>

          {/* Role Column */}
          <td>
            <div className="role-selector skeleton-role" />
          </td>

          {/* Actions Column */}
          <td>
            <div className="action-buttons">
              <div className="action-btn skeleton-action-btn skeleton-btn-edit" />
              <div className="action-btn skeleton-action-btn skeleton-btn-password" />
              <div className="action-btn skeleton-action-btn skeleton-btn-delete" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default UserTableSkeleton;
